import { uniqBy } from 'lodash';
import { Design, NodeType, WorkflowPrompt } from '../../../types';
import { getWfsPrompt } from './get-wfs-prompt';

export function getWfsPrompts(serialized: Design): WorkflowPrompt[] {
  const serializedPrompts = [
    ...serialized.components.modules.flatMap(({ versions }) => {
      return versions[1].flow.nodes;
    }),
    ...serialized.components.objects
  ].filter(({ _class }) => {
    return _class === NodeType.prompt;
  });

  const wfsPrompts = serializedPrompts.flatMap((prompt) => {
    return getWfsPrompt(serialized, prompt);
  });

  return uniqBy(wfsPrompts, 'name');
}
